<ion-app>
       @if (!utilService.isDesktop && userStore.isEulaAccepted) {
       <app-header [title]="menuNavigationService.title" [subTitle]="menuNavigationService.subTitle"></app-header>
       } @else if (utilService.isDesktop && menuNavigationService.productList.length > 0 && userStore.isEulaAccepted) {
       <app-header-desktop></app-header-desktop>
       }

       <ion-content>
              <ion-router-outlet></ion-router-outlet>
       </ion-content>
</ion-app>